import gsap from 'gsap'
// import { Power2 } from 'gsap'
import koko from '../koko-framework/koko'
import { au } from '../koko-framework/shorthand'
// import app from '../koko-framework/app'
import * as PIXI from 'pixi.js'
// import gameState from '../model/GameModel'
import { setupClicker } from '../controller/ButtonController'

export class HudView extends koko.view {
    currentGameView = null;
    enabled = false;

    /* constructor (){
        super();
    } */

    buildView (){
        // var g = app.guiSize, vp = app.viewPort;

        this.children = koko.display.buildLayout([
            { type: 'sprite', id: 'info_btn', name: 'info_btn', x: 123, y: 196, width: 75, height: 63},
            { type: 'sprite', id: 'close_btn', name: 'close_btn', x: 563, y: 196, width: 75, height: 63},

            { type: 'sprite', id: 'timer_mask', name: 'timer_mask', x: 220, y: 204, width: 324, height: 46},
            { type: 'sprite', id: 'timer_fill', name: 'timer_fill', x: 282, y: 204, width: 264, height: 46},
            { type: 'sprite', id: 'timer_top', name: 'timer_top', x: 218, y: 200, width: 329, height: 52},

            { type: 'sprite', id: 'rank3', name: 'rank3', x: 228, y: 205, width: 48, height: 42},
            { type: 'sprite', id: 'rank2', name: 'rank2', x: 225, y: 210, width: 55, height: 33},
            { type: 'sprite', id: 'rank1', name: 'rank1', x: 232, y: 206, width: 40, height: 40},
        ], this.container);

        var g = new PIXI.Graphics();
        g.lineStyle(0);
        g.beginFill(0xffff00, 0.5);
        g.drawPolygon([
            new PIXI.Point(282, 206),
            new PIXI.Point(518, 206),
            new PIXI.Point(540, 226),
            new PIXI.Point(518, 247),
            new PIXI.Point(282, 247),
        ]);
        g.endFill();
        this.container.addChild(g);
        this.children.msk = g;
        this.children.timer_fill.mask = g;

        this.resize();

        /*
        let event = koko.client.system.isMobile ? 'touchstart' : 'mousedown';
        this.children.close_btn.interactive = true;
        this.children.close_btn.on(event, this.showQuitPop);
        this.children.info_btn.interactive = true;
        this.children.info_btn.on(event, this.showTutorialPop);
        */
        this.enabled = false;
    }

    updateTimer(currentTime, maxTime, rank) {
        if (this.children) {
            for (let i = 1; i <= 3; i++) {
                if (rank !== i) {
                    this.children['rank' + i].visible = false;
                } else {
                    this.children['rank' + i].visible = true;
                }
            }
            let timeR = currentTime / maxTime;
            this.children.timer_fill.x = 282 - this.children.timer_fill.width * (1 - timeR);
        }
    }

    resize () {
        // console.log('resize called');
        // v.get('ingamehud').resize();
    }

    transitionIn (currentGameView = null){
        this.currentGameView = currentGameView;
        this.buildView();
        this.show();
        this.enable();
        this.container.alpha = 0;
        gsap.to(this.container, {alpha:1, duration: 0.35, onComplete: this.transitionInDone});
    }

    transitionInDone = () => {
        setupClicker(this.children.close_btn, this.showQuitPop);
        setupClicker(this.children.info_btn, this.showTutorialPop);

        this.enabled = true;
    }

    transitionOut (){
        this.currentGameView = null;
        gsap.to(this.container, {alpha:0, onComplete:this.transitionOutDone, duration: 0.35});
    }

    transitionOutDone = () => {
        // gsap.killAll();
        // this.destroyGameObjects();  
        // game.destroy();
        // game = null;
        this.destroyView();
        this.hide();

        /*
        PIXI.Ticker.shared.stop();
        app.renderer.renderer.plugins.interaction.destroy();

        app.paused = true;
        app.renderer.destroy();
        PIXI.utils.destroyTextureCache();
        */
    }

    showQuitPop = () => {
        if (this.enabled && this.currentGameView && this.currentGameView.showQuitPop) {
            au.play('button', 1, false);
            this.currentGameView.showQuitPop();
        }
    }

    showTutorialPop = () => {
        if (this.enabled && this.currentGameView && this.currentGameView.showTutorial) {
            au.play('button', 1, false);
            this.currentGameView.showTutorial();
        }
    }
}